import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from './toggleContainer.css';

const renderSvg = (icon) => {
  if ('hamburger' === icon) {
    return (
      // This is the 'hamburger' svg
      <svg className={styles.icon} viewBox="0 0 18 14" xmlns="http://www.w3.org/2000/svg"><g fill="none" fillRule="evenodd"><path d="M-3-5h24v24H-3z" /><path d="M0 13c0-.552.445-1 .993-1h16.014c.548 0 .993.444.993 1 0 .552-.445 1-.993 1H.993A.994.994 0 0 1 0 13zm0-6c0-.552.445-1 .993-1h16.014c.548 0 .993.444.993 1 0 .552-.445 1-.993 1H.993A.994.994 0 0 1 0 7zm0-6c0-.552.445-1 .993-1h16.014c.548 0 .993.444.993 1 0 .552-.445 1-.993 1H.993A.994.994 0 0 1 0 1z" fill="currentColor" /></g></svg>
    );
  } else if ('search' === icon) {
    return (
      // This is the 'search' svg
      <svg className={styles.icon} fill="currentColor" viewBox="0 0 18 18" version="1.1" xmlns="http://www.w3.org/2000/svg"><path d="M7.28571429,14.5714286 C3.26192539,14.5714286 0,11.3095032 0,7.28571429 C0,3.26192539 3.26192539,0 7.28571429,0 C11.3095032,0 14.5714286,3.26192539 14.5714286,7.28571429 C14.5714286,11.3095032 11.3095032,14.5714286 7.28571429,14.5714286 Z M7.28571429,13.1142857 C10.5047454,13.1142857 13.1142857,10.5047454 13.1142857,7.28571429 C13.1142857,4.06668317 10.5047454,1.45714286 7.28571429,1.45714286 C4.06668317,1.45714286 1.45714286,4.06668317 1.45714286,7.28571429 C1.45714286,10.5047454 4.06668317,13.1142857 7.28571429,13.1142857 Z" id="Oval" /><rect id="Rectangle-28" transform="translate(14.571429, 14.571429) scale(-1, 1) rotate(45.000000) translate(-14.571429, -14.571429) " x="13.7142857" y="11.1428571" width="1.71428571" height="6.85714286" /></svg>
    );
  }
  return null;
};

const ToggleContainerButton = ({ showModal, label, icon, targetElement }) => (
  <button
    onClick={showModal}
    className={classNames(styles[`${icon}Button`], styles.toggleButton)}
    aria-label={label}
    aria-expanded
    aria-controls={targetElement}
  >
    {renderSvg(icon)}
    <span className={styles.buttonText}>{label}</span>
  </button>
);

ToggleContainerButton.propTypes = {
  showModal: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  targetElement: PropTypes.string.isRequired,
};

export default ToggleContainerButton;
